import o from"styled-components";const d=o.div`
	border-radius: ${({borderRadius:o})=>"number"==typeof o?o:14}px;
	background: ${({theme:o})=>o.bg.card};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	padding: ${({padding:o})=>o||"16px"};
	height: 100%;
	box-sizing: border-box;
`;export{d as PeopleCardContainer};
